$(() => {

  const getDetailsTopNode = (post) => {
    let postBlock = $(post),
        detailsTop = postBlock.find('.bs-post__details-top');
        postCategory = postBlock.find('.bs-post__category'),
        postDate = $(postBlock).find('.bs-post__date');
    if(detailsTop.length === 0) {
      detailsTop = $('<div class="bs-post__details-top"></div>')
      detailsTop.append(postCategory).append(postDate)
      post.append(detailsTop)
        return detailsTop
    } else {
        return $(detailsTop[0])
    }
  }

  const postRestructure = () => {
    const singlePost = $('.blog-single-resource, .bs-posts__featured .bs-post');
    singlePost.each((i,element) => {
      const postDetailsTop = getDetailsTopNode($(element))
      let postInner = $(element).find('.bs-post__details');
      $(postDetailsTop).prependTo( $(postInner) );
    });
  }

  postRestructure();

  $(document).on('facetwp-loaded', () => {
    postRestructure();
  });

});